export default __webpack_public_path__ + "static/filter-referrer-and-breakdown-light-mode-e93fcf8e5d3aff7e9b64fb4ed7a8720d.png";